export const modalNotify = "notify";
export const defaultActions = ["remove", "cancel"] as const;
